import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const HelpModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${Spacing.S32};
`
